import { gql } from '@apollo/client';
import { BaseInducteeInfoFragment, InducteeLandingInfoFragment } from '@/fragments/InducteeInfo';

export const InducteesByClassQuery = gql`
  ${BaseInducteeInfoFragment}
  query GetInducteesByClass($databaseId: ID!) {
    relatedInductees(databaseId: $databaseId) {
      nodes {
        ...BaseInducteeInfo
      }
    }
  }
`;

export const InducteesListQuery = gql`
  ${BaseInducteeInfoFragment}
  query GetInducteeListItems($in: [ID]!) {
    inductees(where: {in: $in}, first: 40) {
      nodes {
        ...BaseInducteeInfo
      }
    }
  }
`;

export const AllInducteesQuery = gql`
  ${InducteeLandingInfoFragment}
  query GetAllInductees {
    allInductees {
      ...InducteeLandingInfo
    }
  }
`;
